/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleStatus = {
    type: 'Enum',
};